<section style="margin-top: 120px;">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                            <strong>We can create a NEW written safety program</strong>.
                        </h3>

                        <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="200">
                            SFI Safety creates customized OSHA-compliant written safety programs for 
                            companies in Colorado, the Carolinas, Arizona, Florida, and nationwide.
                             Our experienced safety consultants work with your team to understand your 
                             operations, hazards, workforce, and existing safety practices so we can build a 
                             program that fits your business—not a generic template.
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                            <li><span class="mediumFontSize"><strong>Every written safety program includes training on how to use, communicate, 
                                and enforce the program effectively.
                                    </strong></span></li>
                            <p class="theme_color fontSize">
                                A safety program is only successful when employees and supervisors understand their responsibilities. 
                                We provide management training to help ensure the program is properly implemented and consistently used.
                            </p>

                            <p class="theme_color fontSize">
                                 Education and training give employers, managers, supervisors, and workers the knowledge and
                                  tools they need to work safely. When appropriate,
                                 our programs also address subcontractor safety management and accountability.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="150">
                            <li><span
                                    class="mediumFontSize"><strong>Our approach is proactive and designed to go Beyond Compliance.</strong></span></li>
                            <p class="theme_color fontSize">
                                Rather than waiting for an injury, OSHA inspection, or regulatory change to identify weaknesses, 
                                we focus on helping clients recognize and address hazards before they lead to an incident.
problem that must be fixed.</p>

                            <p class="theme_color fontSize">
                                 Our programs are built around recognized safety management principles that emphasize identifying hazards,
                                 preventing injuries, strengthening accountability, and continuously improving safety performance.
us today to get started!
                            </p>

                            <p class="theme_color fontSize">
                                <strong>An effective safety program includes these core elements:</strong>
                                
                            </p>
                            <ul>
                                <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-circle fontRed facirclesize"></i> Management Leadership</li>
                                <li data-aos="fade-up" data-aos-delay="200"><i class="fa fa-circle fontRed facirclesize"></i> Worker Participation</li>
                                <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-circle fontRed facirclesize"></i> Hazard Identification and Assessment</li>
                                <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-circle fontRed facirclesize"></i> Hazard Prevention and Control
                                </li>
                                <li data-aos="fade-up" data-aos-delay="500"><i class="fa fa-circle fontRed facirclesize"></i> Education and training</li>
                                <li data-aos="fade-up" data-aos-delay="600"><i class="fa fa-circle fontRed facirclesize"></i> Program Evaluation and Implementation
                                </li>
                                <li data-aos="fade-up" data-aos-delay="700"><i class="fa fa-circle fontRed facirclesize"></i> Communication and Coordination
                                </li>
                            </ul>
                            <p></p>
                            <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="800">
                                OSHA Safety Programs in Texas - call 214-646-1496
                            </p>
                            <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="900">
                                OSHA Safety Programs in Colorado - call 303-649-1304
                            </p>
                            <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="950">
                                OSHA Safety Programs in Arizona - call 602-325-1950
                            </p>
                            <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="1000">
                                We also provide <a href="/safetytraining">Safety Training</a> and <a href="/safetyinspection">Safety Inspections</a> 
                            </p>
                        </ul>

                        
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>